import React from "react";
import create from "zustand";
import { stringify } from "querystring";

import APITaskMethod from "../datos/json/APITaskMethod.json";
import apiCall from "../api"; //llamada al api

const filesStore = create((set, get:any) => ({
  uploadFilesbyTopic:[],
  isLoading: false,
  filesDropzone:[],
  objError: {  store:'f', url: "", recurso: "", body: "", hasError: false, function:"", resultado: { "idresul": 0,  "desresul": "" } }, 
  
  setGuardaFiles: async (posicion:any, file:any) => {
    //alert('setTopicSelectDefault - Regresa los valores por omisión');
    try{
      let fiDr= get().filesDropzone;
      let infoFile={};
      infoFile={"posi": posicion, "file":file};
      let idx= fiDr.findIndex((i:any)=>i.posi===posicion);
      if (idx>-1){
        fiDr[idx]= infoFile;
      }
      else{
        fiDr.push(infoFile);
      }
      console.log("fiDr Guarda", fiDr);
        set({ filesDropzone: fiDr, 
              isLoading: false, 
              objError: { url: "", recurso: "", body: "", hasError: false,  function:"", resultado: { "idresul": 0,  "desresul": "" } }
        });
    } catch (error){
         get().setObjError('', '', '', true, 'setUploadFilesDefault', -200, 'Error al inicializar ')
    } finally{
         set({ isLoading:false });
    };
  },
  
  setEliminaFiles: async (posicion:any) => {
    //alert('setTopicSelectDefault - Regresa los valores por omisión');
    try{
      let fiDr= get().filesDropzone;
      let idx= fiDr.findIndex((i:any)=>i.posi===posicion);
      if (idx>-1){
        fiDr.splice(idx, 1);
      }
      console.log("fiDr Elimina", fiDr);
       set({ filesDropzone: fiDr, 
              isLoading: false, 
              objError: { url: "", recurso: "", body: "", hasError: false,  function:"", resultado: { "idresul": 0,  "desresul": "" } }
        });
    } catch (error){
         get().setObjError('', '', '', true, 'setUploadFilesDefault', -200, 'Error al inicializar ')
    } finally{
         set({ isLoading:false });
    };
  },



    setObjError: async (u:any, r:any, b:any, h:any, f:any, i:any, d:any) => {
      //alert('setObjError' );
      let objErrorInt = { store:'f', url:u, recurso:r, body:b, hasError:h, function:f, resultado:{ "idresul":i,  "desresul":d } };
      try{
          set({ objError: objErrorInt});
      } catch (error){
          objErrorInt.hasError = true;
          objErrorInt.function = "setObjError (filesStore)";
          objErrorInt.resultado.idresul = -200;
          objErrorInt.resultado.desresul = "Error al asignar el objeto de errores";
          set( { objError:objErrorInt } );
      } finally{
          set({ isLoading:false });
      };
      if (objErrorInt.hasError)
        console.log('Error (objError): ', get().objError.resultado.idresul, ' ... ', get().objError.resultado.desresul);
    },

  setUploadFilesDefault: async () => {
    //alert('setTopicSelectDefault - Regresa los valores por omisión');
    try{
        set({ uploadFilesbyTopic: [], 
              isLoading: false, 
              objError: { url: "", recurso: "", body: "", hasError: false,  function:"", resultado: { "idresul": 0,  "desresul": "" } }
        });
    } catch (error){
         get().setObjError('', '', '', true, 'setUploadFilesDefault', -200, 'Error al inicializar ')
    } finally{
         set({ isLoading:false });
    };
  },
  
  getUploadFilesbyTopic: async (token:any, id:any, filesSel:any) => {
    const API_ENV= process.env.REACT_APP_ENV
    const API_URL= process.env.REACT_APP_API_URL;
    const API_ESQ:any = process.env.REACT_APP_API_SCHEMA;
    const API_TASK = APITaskMethod.methods[3].name + APITaskMethod.methods[3].task[0].name;//Files/UploadFilesbyTopic;
    const API_HEADERS = {"Authorization":token};
    const API_BODY = "";//formData;
    const API_PARAMS = { "url": API_URL+API_TASK , "method":"post", "headers":API_HEADERS };
    //const API_HEADERS = {"Content-Type": "undefined","Authorization":token,"FormData": }; // ojo al mandar archivos a la nas no se manda content-type
    const formData = new FormData();
    formData.append("idtema", id);
    formData.append("esquema", API_ESQ);
    filesSel.map((e:any) => {
      formData.append("files", e,e.name);
     });  
    //console.clear();
    //console.log ('API_ENV: ', API_ENV, ' API_URL: ', API_URL, ' API_HEADERS: ', API_HEADERS);
    //console.log ('API_BODY: ', API_BODY );
    //console.log ('**API_PARAMS: ', API_PARAMS );

    get().setObjError('', '', '', false, '', 0, ''); 
    try {
         set({ uploadFilesbyTopic:[] });
         const uploadResult= await apiCall(API_PARAMS,formData); //api

        
         if (uploadResult.resultado.idresul===200 || uploadResult.resultado.idresul===0) {
            set( { uploadFilesbyTopic: uploadResult } );
            //console.log("**getuploadFilesbyTopic - carga de archivos en la NAS");
            //console.log("*uploadFilesbyTopic: ", get().uploadFilesbyTopic);
            return(get().uploadFilesbyTopic);
         }
         else{
            get().setObjError(API_URL, API_TASK, API_BODY, true, 'getUploadFilesbyTopic', uploadResult.resultado.idresul, uploadResult.resultado.desresul); 
            return(get().objError);
         }
    } catch (error) {
            console.log("error catch: ", error);
            set( { uploadFilesbyTopic: [] } );
            get().setObjError(API_URL, API_TASK, API_BODY, true, 'getUploadFilesbyTopic', -200,'Error de API, no identificado'); 
          return(get().objError); 
    } finally {
          set( { isLoading: false } );
    }
  },
  
  
}));

export default filesStore;

//RESUMEN
// setUploadFilesDefault - función con valores por default 
// getUploadFilesbyTopic - función que manda archivos a la NAS
// uploadFilesbyTopic -  respuesta del API al subir los archivos a la NAS
// isLoading - elemento para ver la carga
// errorMessage -  guarda posible mensaje de error
// hasError - bandera (True/False) que nos dice si hay errores
// funtionError - nombre de la función con error
